import { useQuery } from '@tanstack/react-query';
import type AgentApiProvidedJobPostListsRecord from '@/types/serializers/AgentApiProvidedJobPostListsRecord';

export type ProvidedJobPostListRecord = AgentApiProvidedJobPostListsRecord;

type IndexResponse = {
  records: ProvidedJobPostListRecord[];
};

export const PROVIDED_JOB_POST_LISTS_QUERY_KEY = '/agent/api/provided_job_post_lists';

export default function useProvidedJobPostLists() {
  return useQuery({
    queryKey: [PROVIDED_JOB_POST_LISTS_QUERY_KEY],
    queryFn: async () => {
      const response = await fetch('/agent/api/provided_job_post_lists.json');
      if (!response.ok) throw new Error('Failed to fetch lists');
      const data: IndexResponse = await response.json();
      return data.records;
    },
  });
}
